import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faBars,
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Menu_Offcanvas from "./menu_offcanvas/Menu_Offcanvas";
import { Form } from "react-bootstrap";
import context from "react-bootstrap/esm/AccordionContext";
import { Context } from "../../utils/context";
import { Products } from "../../utils/luxuryapis/Product/Product";
import { encodeId } from "../../utils/common";
function LuxuryHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false); // state to control navbar toggle

  const handleNavClick = () => {
    setExpanded(false);
  };

  const [show, setShow] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const { signin } = useContext(Context);
  const [name, setName] = useState("");
  const [productdata, setproductData] = useState();
  const getAllData = async (name) => {
    let res = await Products({ name });
    if (res?.success) {
      setproductData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData(name);
  }, [name]);

  return (
    <>
      <section className={`main_head ${showSearch ? "active" : ""}`}>
        <div className="container-fluid p-0">
          <div className="custom_container">
            <div className="desktop_view">
              <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
                <div className="left_side">
                  <div
                    className="menu_holder"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faBars} className="inner_icon" />
                    <p className="menu_text">Menu</p>
                  </div>

                  <div className="main_search_div">
                    <div className="search_holder">

                      <div
                        className="icon_holder"
                        onClick={() => setShowSearch(true)}
                      >
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className="search_icon"
                        />
                      </div>

                      <div
                        className={`input_holder ${showSearch ? "active" : ""}`}
                      >
                        <Form.Control
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <div
                          className="close_icon_holder"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSearch(false);
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faXmark}
                            className="close_icon"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className={`suggested_searches ${
                        showSearch ? "active" : ""
                      }`}
                    >
                      <p className="title_text">SUGGESTED SEARCHES</p>
                      <div className="all_searches_div">
                        {productdata?.data?.map((val) => (
                          <p
                            className="search_text"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowSearch(false);
                              navigate(`/luxury/product-details/${encodeId(val?.id)}`);
                            }}
                          >
                            {val?.name}
                          </p>
                        ))}
                      
                      </div>
                    </div>
                  </div>
                </div>

                <Navbar.Brand href="#home">
                  <div className="logodiv">
                    <Link to="/luxury/home">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assest/image/logo/header-logo.png"
                        }
                        alt="Logo"
                        className="logo-img"
                      />
                    </Link>
                  </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <div className="right_side">
                  <Navbar.Collapse
                    id="basic-navbar-nav"
                    className="desktop_nav"
                  >
                    <Nav className="">
                      {signin && (
                        <Nav.Link
                          as={Link}
                          to="/luxury/account"
                          className={
                            location.pathname === "/luxury/account"
                              ? "active"
                              : ""
                          }
                          onClick={handleNavClick}
                        >
                          <img
                            src="/assest/image/header/uesr.png"
                            className="inner_img"
                          />
                          <p className="inner_text">Account</p>
                        </Nav.Link>
                      )}

                      <Nav.Link
                        as={Link}
                        to="/luxury/cart"
                        className={
                          location.pathname === "/luxury/cart" ? "active" : ""
                        }
                        onClick={handleNavClick}
                      >
                        <img
                          src="/assest/image/header/bag.png"
                          className="inner_img"
                        />

                        <p className="inner_text">Cart</p>
                      </Nav.Link>

                      {signin && (
                        <Nav.Link
                          as={Link}
                          to="/luxury/wishlist"
                          className={
                            location.pathname === "/luxury/wishlist"
                              ? "active"
                              : ""
                          }
                          onClick={handleNavClick}
                        >
                          <img
                            src="/assest/image/header/wishlist.png"
                            className="inner_img"
                          />

                          <p className="inner_text">Wishlist</p>
                        </Nav.Link>
                      )}
                    </Nav>
                  </Navbar.Collapse>
                </div>
              </Navbar>

              <div className="main_search_div mobile_search_div">
                <div className={`search_holder ${showSearch ? "active" : ""}`}>
                  <div className={`input_holder ${showSearch ? "active" : ""}`}>
                    <Form.Control type="text" />

                    <div
                      className="close_icon_holder"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} className="close_icon" />
                    </div>
                  </div>
                </div>

                {/* <div
                  className={`mobile_search suggested_searches ${
                    showSearch ? "active" : ""
                  }`}
                >
                  <p className="title_text">SUGGESTED SEARCHES</p>
                  <div className="all_searches_div">
                    <p
                      className="search_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                        navigate("/luxury/home");
                      }}
                    >
                      Games(10)
                    </p>
                    <p
                      className="search_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                        navigate("/luxury/home");
                      }}
                    >
                      Barware(12)
                    </p>
                    <p
                      className="search_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                        navigate("/luxury/home");
                      }}
                    >
                      Drinkware(12)
                    </p>
                    <p
                      className="search_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                        navigate("/luxury/home");
                      }}
                    >
                      Stamps(12)
                    </p>
                    <p
                      className="search_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(false);
                        navigate("/luxury/dgp-autograph-collection");
                      }}
                    >
                      Autograph collection(42)
                    </p>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="mobile_view">
              <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
                <Navbar.Brand href="#home">
                  <div className="logodiv">
                    <Link to="/luxury/home">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assest/image/logo/header-logo.png"
                        }
                        alt="Logo"
                        className="logo-img"
                      />
                    </Link>
                  </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="">
                    <Nav.Link
                      as={Link}
                      to="/luxury/account"
                      className={
                        location.pathname === "/luxury/account" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      <img
                        src="/assest/image/header/uesr.png"
                        className="inner_img"
                      />
                      <p className="inner_text">Account</p>
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to="/luxury/cart"
                      className={
                        location.pathname === "/luxury/cart" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      <img
                        src="/assest/image/header/bag.png"
                        className="inner_img"
                      />

                      <p className="inner_text">Cart</p>
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to="/luxury/wishlist"
                      className={
                        location.pathname === "/luxury/wishlist" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      <img
                        src="/assest/image/header/wishlist.png"
                        className="inner_img"
                      />

                      <p className="inner_text">Wishlist</p>
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </div>
          </div>
        </div>
      </section>

      <Menu_Offcanvas show={show} onHide={() => setShow(false)} />
    </>
  );
}

export default LuxuryHeader;
